module.exports = __webpack_public_path__ + "static/media/img_flipCards-07.c38566eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-07.png
// module id = 442
// module chunks = 4